import * as React from 'react';
import { ReactComponent as SearchIconSVG } from '../../assets/icons/mevo/ic_search.svg';
import IconPattern, { IconProps } from './_IconPattern';

const SearchIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={SearchIconSVG} variantPlaces={1} {...props} />;
};

export default SearchIcon;
